import _ from '@/utils/lodash-optimized'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import {
  NameSuffixCodes,
  ContactPointCodes,
  AdministrativeGenderCodes,
  ResidenceTypeCodes,
  USStateCodes,
  Education,
  LanguageCodes,
  RaceCodes,
  MaritalStatusCodes
} from '../../../lib/Codes'
import http from '../../../lib/http'
import { notify } from '../../../lib/Notification/actions'
import * as Client from '../../../selectors/client'
import { getEnrollmentStatus } from '../../../selectors/patient'
import { getOnlyAvailableUserClients } from '../../../selectors/user'
import { Invite } from '../../PatientFolder/Standard/Demographics/Patient/invite'
import { InviteHistory } from '../../PatientFolder/Standard/Demographics/Patient/invite-history'
import FriendlyDate from '../Date/FriendlyDate'
import {
  YesNoRadioOptions,
  bindTargetMixin,
  CancelButton,
  CheckboxInput,
  Collection,
  DateInput,
  Fieldset,
  getOrEmpty,
  IconCheckInput,
  MaskedTextInput,
  preferredUpdate,
  RadioGroupInput,
  SaveButton,
  SelectInput,
  TextInput,
  today,
  Validators,
  removeBlanks
} from '../FormBuilder'
import { CircularProgress, Card } from '../NarusMaterial'

import { updatePatientModalClientName } from './actions'

import './styles.scss'

const mapCodeForSelect = options =>
  options.map(o => ({
    label: o.display || o.label,
    value: o.code || o.value
  }))

class PatientCreateForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.addStyleToFirstMobile = this.addStyleToFirstMobile.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.sendMobileAppInvite = this.sendMobileAppInvite.bind(this)
    this.handleInvitePhoneSelect = this.handleInvitePhoneSelect.bind(this)

    // collapse states + binds
    this.toggleInviteAccessOpen = this.toggleInviteAccessOpen.bind(this)
    this.toggleInviteHistoryOpen = this.toggleInviteHistoryOpen.bind(this)
    this.handleInviteAccessKeyDown = this.handleInviteAccessKeyDown.bind(this)
    this.handleInviteHistoryKeyDown = this.handleInviteHistoryKeyDown.bind(this)

    this.toggleInvitePreview = this.toggleInvitePreview.bind(this)
    // this.setInvitePreviewTab = this.setInvitePreviewTab.bind(this)
    this.setPreviewTab = this.setPreviewTab.bind(this)

    this.state.showInvitePreview = false
    this.state.previewTab = 'ios'

    if (!this.state) {
      this.state = {}
    }
    this.state.inviteAccessOpen = true
    this.state.inviteHistoryOpen = true

    this.state.showInvitePreview = false
    this.state.invitePreviewTab = 'ios' // 'ios' | 'android'
  }

  getValue () {
    return { ...this.state.value }
  }

  componentDidMount () {
    const value = this.getValue()

    value.phones = getOrEmpty(value.phones)
    value.faxes = getOrEmpty(value.faxes)
    value.emails = getOrEmpty(value.emails)

    this.setState({
      isSubmitting: false,
      value,
      initialValue: value,
      invitePhone: ''
    })
  }

  componentDidUpdate (prevProps, prevState) {
    const { dispatch } = this.props
    const {
      value: { clientName, phones, emails }
    } = this.state
    const {
      value: {
        clientName: prevClientName,
        phones: prevPhones,
        emails: prevEmails
      }
    } = prevState

    if (clientName !== prevClientName) {
      dispatch(updatePatientModalClientName(clientName))
    }

    if (phones.length > 1) {
      preferredUpdate(prevPhones, phones, this.state.value, this, 'phones')
    }

    if (emails.length > 1) {
      preferredUpdate(prevEmails, emails, this.state.value, this, 'emails')
    }
  }

  findFirstMobileNumber () {
    const {
      value: { phones }
    } = this.state
    if (!phones) {
      return false
    }

    const findMobilePhone = () =>
      phones.filter(p => {
        if (p.phoneType === 'mobile') {
          return p
        }
        return false
      })
    const foundMobilePhone = findMobilePhone().length
      ? findMobilePhone()[0]
      : false
    if (!foundMobilePhone) {
      return false
    }
    return _.findIndex(phones, foundMobilePhone)
  }

  addStyleToFirstMobile (currentIndex) {
    const { enrollments } = this.props
    const {
      value: { id }
    } = this.state
      const enrollmentPhone = enrollments?.[`Patient/${id}`]?.phone
    if (enrollmentPhone) {
      return ''
    }
    if (currentIndex === this.findFirstMobileNumber()) {
      return 'nh-highlight-mobile'
    }
    return ''
  }

  handleSubmit = () => {
    this.props.onSubmit(this.getValue())
  }

  handleInvitePhoneSelect (valueOrEvent) {
    const value = valueOrEvent && valueOrEvent.target
      ? valueOrEvent.target.value
      : valueOrEvent
    this.setState({ invitePhone: value })
  }

  async sendMobileAppInvite (platform) {
    const { value } = this.state
    const { dispatch } = this.props

    try {
      await http.postRequest(`/patients/${value.id}/mobile-app-invitation`, {
        platform
      })

      const platformName = platform === 'ios' ? 'iOS' : 'Android'
      dispatch(notify(`${platformName} app invitation sent successfully`, false))
    } catch (error) {
      console.error('Failed to send mobile app invitation:', error)
      dispatch(notify('Failed to send mobile app invitation', true))
    }
  }

  toggleInviteAccessOpen () {
    this.setState(s => ({ inviteAccessOpen: !s.inviteAccessOpen }))
  }

  toggleInviteHistoryOpen () {
    this.setState(s => ({ inviteHistoryOpen: !s.inviteHistoryOpen }))
  }

  toggleInvitePreview () {
    this.setState(s => ({ showInvitePreview: !s.showInvitePreview }))
  }

  setPreviewTab (tab) {
    this.setState({ previewTab: tab })
  }

  // setInvitePreviewTab (tab) {
  //   this.setState({ invitePreviewTab: tab })
  // }

  handleInviteAccessKeyDown (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggleInviteAccessOpen()
    }
  }

  handleInviteHistoryKeyDown (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.toggleInviteHistoryOpen()
    }
  }

  renderEnrollment () {
    const { value } = this.state
    const { profile: { app_metadata: appMetadata } } = this.props

    if (!value.id) {
      return false
    }

    const showMemberPortalMemberId = [ 'executive_director', 'administrator', 'medical_director' ].includes(appMetadata?.roles?.meta?.role)
    const declined = Boolean(this.state.value && this.state.value.declinedMobileEnrollment)

    return (
      <div>
        {showMemberPortalMemberId && (
          <TextInput
            label='Member Portal Member Id'
            name='memberPortalMemberID'
          />
        )}

        <Invite
          declined={declined}
          declinedMobileEnrollment={this.state.value.declinedMobileEnrollment}
          phones={value.phones}
        />

        {!(this.state.value && this.state.value.declinedMobileEnrollment) && (
          <InviteHistory />
        )}
      </div>
    )
  }

  renderCustomerName () {
    const { isNewPatient } = this.props

    if (!isNewPatient) {
      return (
        <div className='top-right-corner'>
          <CheckboxInput
            name='isVIPPatient'
            label='VIP Patient'
          />
          <div style={{ marginTop: '0.5rem' }}>
            <CheckboxInput
              name='writtenConsent'
              label='Consent'
            />
          </div>
          <div style={{ marginTop: '0.5rem' }}>
            <CheckboxInput
              name='doNotCall'
              label='Do not call'
            />
          </div>
        </div>
      )
    }

    return (
      <div className='row between-xs'>
        <div className='col-xs-6 col-sm-6 col-md-6'>
          <SelectInput
            options={this.props.clients.map(c => ({
              value: c.clientName,
              label: c.display
            }))}
            label='Client Name'
            name='clientName'
            required
          />
        </div>
        <div className='col-xs-6 col-sm-6 col-md-6 checkbox-cell'>
          <CheckboxInput
            name='writtenConsent'
            label='Consent'
          />
        </div>
      </div>
    )
  }

  renderOther () {
    const other = (this.state.value.other || []).sort(
      (a, b) => a.rank - b.rank
    )

    const { phonesDate } = this.state.value

    const renderHeader = () => {
      const headers = [
        'Rank',
        'Phone Number',
        'Listing Name',
        'Relationship',
        'First Seen',
        'Last Seen',
        'Phone Type',
        'Line Type'
      ]
      return (
        <thead>
          <tr>
            {headers.map((header, index) => (
              <th
                key={`header-cell-${index}`}
                className='not-sortable'
              >
                {header}
              </th>
            ))}
          </tr>
        </thead>
      )
    }

    const renderRow = (telecom, index) => {
      const {
        rank,
        value,
        listing_name: listingName,
        relationship,
        first_seen: firstSeen,
        last_seen: lastSeen,
        phone_type: phoneType,
        line_type: lineType
      } = telecom
      return (
        <tr
          className='data-row'
          key={`telecom${index}_${rank}`}
        >
          <td>{rank}</td>
          <td>{value}</td>
          <td>{listingName}</td>
          <td>{relationship}</td>
          <td>{firstSeen}</td>
          <td>{lastSeen}</td>
          <td>{phoneType}</td>
          <td>{lineType}</td>
        </tr>
      )
    }
    const renderBody = rows =>
      rows.map((row, index) => renderRow(row, index))
    return (
      <div style={{ marginBottom: '1em' }}>
        <div className='row top-xs top-right-corner'>
          <div
            className='col-md-12'
            style={{
              color: '#222222',
              marginBottom: '1em'
            }}
          >
            <span className='nh-no-wrap'>
              {'Last Updated: '}
              {phonesDate
                ? (
                  <FriendlyDate
                    date={phonesDate}
                    short={false}
                  />
                )
                : (
                  'N/A'
                )}
            </span>
          </div>
        </div>
        <table className='accordionTable'>
          {renderHeader()}
          <tbody>{renderBody(other)}</tbody>
        </table>
      </div>
    )
  }

  render () {
    const { divisions } = this.props
    const saveClassName = this.props.modal ? 'modal-actions' : 'row end-xs'
    const { initialValue } = this.state

    const enrollment = this.props.enrollments[`Patient/${this.state.value.id}`]
    const isEnrollmentEmailVerified =
        enrollment?.status ?? '' === 'email-confirmed'

    const style = {
      subHeader: {
        color: '#979797',
        marginBottom: '1rem',
        marginTop: '1rem'
      },
      alignBaseline: {
        alignItems: 'baseline'
      }
    }

    const divisionsOptions = divisions.map(o => ({
      label: o,
      value: o
    }))

    const patientFormContent = (
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className='patient-form'>
          <div className='row hidden'>
            <div>
              <input
                type='hidden'
                name='id'
              />
              <input
                type='userId'
                name='userId'
              />
              <TextInput
                label='Patient ID'
                name='patientId'
              />
            </div>
          </div>
          {this.renderCustomerName()}
          <div className='row'>
            <div className='col-xs-12 col-sm-6'>
              <SelectInput
                options={divisionsOptions}
                label='Division'
                name='clientDivision'
              />
            </div>
          </div>
          <div className='row top-xs'>
            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                label='First Name'
                name='firstName'
                required
                info='show me money'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                label='Middle Name'
                name='middleName'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='Last Name'
                name='lastName'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-2'>
              <SelectInput
                options={NameSuffixCodes}
                label='Suffix'
                name='suffix'
              />
            </div>
          </div>
          <div className='row top-xs'>
            <div className='col-xs-12 col-sm-6 col-md-3'>
              <TextInput
                label='Preferred Name'
                name='preferredName'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3 mui-date-picker-extended'>
              <DateInput
                label='Date of Birth'
                name='dob'
                maxDate={today}
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <SelectInput
                options={AdministrativeGenderCodes}
                label='Gender'
                name='gender'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-3'>
              <MaskedTextInput
                label='Social Security Number'
                name='SSN'
                mask='111-11-1111'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                options={MaritalStatusCodes}
                label='Marital Status'
                name='maritalStatus'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4 mui-date-picker-extended'>
              <DateInput
                label='If Married When?'
                name='dateMarried'
                maxDate={today}
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                options={RaceCodes}
                label='Race'
                noFormBuild
                name='race'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <SelectInput
                name='preferredLanguage'
                options={LanguageCodes}
                label='Preferred Language'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <SelectInput
                name='educationLevel'
                options={Education}
                label='Education'
              />
            </div>
          </div>
          <div
            className='row'
            style={style.alignBaseline}
          >
            <div className='col-xs-12 col-sm-6 col-md-3'>
              <span style={style.subHeader}>Are you adopted?</span>
              <br />
              <br />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-5'>
              <RadioGroupInput
                name='adopted'
                options={YesNoRadioOptions}
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4 mui-date-picker-extended'>
              <DateInput
                label='If Adopted When?'
                name='whenAdopted'
                maxDate={today}
              />
            </div>
          </div>
          <div className='row top-xs margin-top'>
            <div className='col-xs-12'>
              <h2>Address</h2>
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 1'
                name='address1'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Address 2'
                name='address2'
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <TextInput
                label='City'
                name='city'
                required
              />
            </div>

            <div className='bottom-xs col-xs-12 col-sm-6 col-md-4'>
              <SelectInput
                label='State'
                name='usState'
                options={USStateCodes}
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-4'>
              <MaskedTextInput
                label='Zip'
                name='zip'
                mask='11111'
                required
              />
            </div>

            <div className='col-xs-12 col-sm-6 col-md-6'>
              <TextInput
                label='County'
                name='county'
              />
            </div>
            <div className='col-xs-12 col-sm-6 col-md-6'>
              <SelectInput
                name='residenceType'
                options={ResidenceTypeCodes}
                label='Residence Type'
              />
            </div>
          </div>
          <div>
            <div className='row top-xs margin-top'>
              <div className='col-xs-12'>
                <h2>Contact</h2>
              </div>
            </div>

            {this.renderOther()}

            <Collection
              name='phones'
              addStyleFn={index => this.addStyleToFirstMobile(index)}
            >
              <Fieldset>
                <div className='checkbox-wrapper'>
                  <IconCheckInput
                    name='preferred'
                    checkedIcon='star'
                    uncheckedIcon='star-o'
                  />
                </div>
                <div className='row'>
                  <div className='col-xs-12 col-sm-3 col-md-3'>
                    <SelectInput
                      name='phoneType'
                      label='Phone Type'
                      options={mapCodeForSelect(
                        ContactPointCodes.contactPointUse
                      )}
                    />
                  </div>
                  <div className='col-xs-12 col-sm-5 col-md-5'>
                    <MaskedTextInput
                      mask='111.111.1111'
                      name='number'
                      label='Phone Number'
                      validators={[ Validators.phone() ]}
                    />
                  </div>
                  <div className='col-xs-12 col-sm-4 col-md-4'>
                    <SelectInput
                      name='status'
                      label='Status'
                      noSort
                      options={ContactPointCodes.contactStatus}
                    />
                  </div>
                </div>
              </Fieldset>
            </Collection>
            <Collection name='emails'>
              <Fieldset>
                <div className='checkbox-wrapper'>
                  <IconCheckInput
                    name='preferred'
                    checkedIcon='star'
                    uncheckedIcon='star-o'
                  />
                </div>
                <div className='row'>
                  <div className='col-xs-12 col-sm-10 col-md-10'>
                    <TextInput
                      name='address'
                      label='Email'
                      validators={[ Validators.email() ]}
                    />
                  </div>
                </div>
              </Fieldset>
            </Collection>
          </div>
          <div className='row top-xs margin-top'>
            <div className='col-xs-12'>
              <h2>Occupation</h2>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Occupation'
                name='occupation'
              />
            </div>
            <div className='col-xs-12 col-sm-6'>
              <TextInput
                label='Employer / School'
                name='employer'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12'>
              <h2>Notes</h2>
            </div>
            <div className='col-xs-12 col-sm-12'>
              <TextInput
                label='Notes'
                name='notes'
              />
            </div>
          </div>
          {this.renderEnrollment()}
          <div className={saveClassName}>
            {isEnrollmentEmailVerified && (
              <div className='row col-xs-9'>
                <div className='col-xs-14'>
                  <Card
                    barColor='blue'
                    height='auto'
                    style={{ background: '#e1ecfb' }}
                  >
                    <div style={{ float: 'left' }}>
                      <i className='fa fa-info-circle' />
                    </div>
                    <div style={{ marginLeft: '30px' }}>
                      Please click the Revoke button if getting an error resending
                      an invitation email
                    </div>
                  </Card>
                </div>
              </div>
            )}

            <CancelButton
              label='Cancel'
              formKey={this.props.formKey}
              onClick={() => {
                this.setState({
                  ...this.state,
                  errors: null,
                  value: initialValue
                })
              }}
            />

            <SaveButton
              formKey={this.props.formKey}
              disabled={removeBlanks(this.state.errors)}
              onClick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    )

    return (
      <div className='main'>
        {this.props.patientForm.loading
          ? (
            <CircularProgress />
          )
          : (
            patientFormContent
          )}
      </div>
    )
  }
}

PatientCreateForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isNewPatient: PropTypes.bool
}

const mapStateToProps = redux => ({
  patientForm: redux.patientForm,
  clients: getOnlyAvailableUserClients(redux),
  divisions: Client.getDivisions(redux),
  enrollments: redux.enrollments2,
  patientStatus: getEnrollmentStatus(redux),
  profile: redux.auth.profile
})

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(PatientCreateForm)
